import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { destinationGroupApi } from '../../api/lib/destination-group';
import { destinationGroupsKeys } from '../../api/query-keys/destination-groups';
import { DestinationGroup } from '../../api/types/destination-group';

export const useDestinationGroup = (id: number) => {
  return useQuery<DestinationGroup, ApiError>({
    queryKey: destinationGroupsKeys.detail(id),
    queryFn: () => destinationGroupApi.fetchDestinationGroup(id),
  });
};
